import findLastTextNode from '../helpers/find-last-text-node';

const isLastTextNodeOfElement = (textNode, element) => findLastTextNode(element) === textNode;

export default isLastTextNodeOfElement;
